// extracted by mini-css-extract-plugin
export var centerText = "_92-8";
export var container = "_92-0";
export var doughnutContainer = "_92-7";
export var legend = "_92-a";
export var legendItemColorDisplay = "_92-b";
export var legendItemLabel = "_92-d";
export var legendItemValue = "_92-c";
export var lg = "_92-5";
export var maxWidth = "_92-9";
export var md = "_92-4";
export var responsive = "_92-6";
export var sm = "_92-3";
export var xs = "_92-2";
export var xxs = "_92-1";